const showItem = (trigger, target) => {
    target.hidden = false;
    target.style.maxHeight = target.scrollHeight.toString() + 'px';
    trigger.setAttribute('aria-expanded', 'true');
};
const hideItem = (trigger, target) => {
    target.style.maxHeight = '0';
    trigger.setAttribute('aria-expanded', 'false');
};
const init = (root) => {
    root.classList.add('initialized');
    const triggers = root.querySelectorAll('button[aria-expanded][aria-controls]');
    Array.from(triggers).forEach((trigger) => {
        const targetId = trigger.getAttribute('aria-controls');
        const target = root.querySelector(`#${targetId}`);
        if (!target) {
            return;
        }
        trigger.addEventListener('click', () => {
            const expanded = trigger.getAttribute('aria-expanded') === 'true';
            expanded ? hideItem(trigger, target) : showItem(trigger, target);
        });
        target.addEventListener('transitionend', () => {
            if (!target.hidden && target.style.maxHeight === '0') {
                target.hidden = true;
            }
        });
        document.addEventListener('resize', () => {
            if (!target.hidden) {
                target.style.maxHeight = target.scrollHeight.toString() + 'px';
            }
        });
    });
    window.setTimeout(() => {
        const lazyImages = root.querySelectorAll('img[loading="lazy"]');
        lazyImages.forEach((image) => image.removeAttribute('loading'));
    }, 1000);
};
export const initAccordion = (root = document) => {
    const elements = root.querySelectorAll('.js-accordion:not(.initialized)');
    Array.from(elements).forEach((root) => {
        init(root);
    });
};
